import { useMutation, useQueryCache } from 'react-query';
import { EventCategoryAPI } from 'api/admin/eventCategory';
import { EVENT_CATEGORIES } from 'helpers/constants';
import dispatchToast from 'helpers/dispatchToast';

export default function useCreateEventCategory() {
  const queryCache = useQueryCache();

  return useMutation(EventCategoryAPI.add, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: 'success' });
      queryCache.invalidateQueries(EVENT_CATEGORIES);
      onSuccess();
    },
  });
}
